import { useNavigate, useLocation } from "react-router-dom";

// Smooth-scrolls to an on-page section when already home,
// otherwise routes home (or to another page) first.
export const useGo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (href) => (e) => {
    e.preventDefault();
    if (href.startsWith("#")) {
      if (location.pathname === "/") {
        document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate("/" + href);
      }
    } else {
      navigate(href);
      window.scrollTo(0, 0);
    }
  };
};
